// extracted by mini-css-extract-plugin
module.exports = {"userAccount":"ManageUserProfile_userAccount__1_4ZC","userDropdown":"ManageUserProfile_userDropdown__3Ded2","userInfo":"ManageUserProfile_userInfo__oVoGl"};